// extracted by mini-css-extract-plugin
export default {"nav":"map--nav--ppnIf","btn":"map--btn--kjUNg"};